import React, { useState } from 'react';
import { usePublicConfig } from '../config/demo.js';

const DISMISS_KEY = 'chargeos-demo-ribbon-dismissed';

/**
 * Slim notice shown on demo environments so nobody mistakes simulated payments, messages or
 * chargers for the real thing. Dismissing it lasts for the browser session only.
 */
export default function DemoRibbon() {
  const { demoMode } = usePublicConfig();
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });
  if (!demoMode || hidden) return null;
  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* private mode: just hide it */ }
    setHidden(true);
  };
  return (
    <div className="chargeos-demo-ribbon" role="note" id="demo-ribbon">
      <i className="fas fa-flask me-2" aria-hidden="true" />
      <span><strong>Demo environment</strong> — payments, emails/SMS and chargers that are not connected are simulated.</span>
      <button type="button" className="btn-close btn-close-sm ms-2" aria-label="Dismiss demo notice" onClick={dismiss} />
    </div>
  );
}
